var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg24Support(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.8617H17.24C16.44 18.8617 15.68 19.1717 15.12 19.7317L13.41 21.4218C12.63 22.1918 11.36 22.1918 10.58 21.4218L8.87 19.7317C8.31 19.1717 7.54 18.8617 6.75 18.8617H6C4.34 18.8617 3 17.5317 3 15.8917V4.98169C3 3.34169 4.34 2.01172 6 2.01172H18C19.66 2.01172 21 3.34169 21 4.98169V15.8917C21 17.5217 19.66 18.8617 18 18.8617Z",
    stroke: "#7A9526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.16272C7 8.23272 7.76 7.47266 8.69 7.47266C9.62 7.47266 10.38 8.23272 10.38 9.16272C10.38 11.0427 7.71 11.2427 7.12 13.0327C7 13.4027 7.31 13.7727 7.7 13.7727H10.38",
    stroke: "#7A9526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 13.7608V8.05088C16.0417 7.79088 15.8717 7.56083 15.6217 7.49083C15.3717 7.42083 15.1017 7.52083 14.9617 7.74083C14.2417 8.90083 13.4617 10.2208 12.7817 11.3808C12.6717 11.5708 12.6717 11.8208 12.7817 12.0108C12.8917 12.2008 13.1017 12.3208 13.3317 12.3208H17.0017",
    stroke: "#7A9526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Support);
export default __webpack_public_path__ + "static/media/24-support.e69d7329b4a1a8f8e37aa0f3eafddc19.svg";
export { ForwardRef as ReactComponent };